import { mapState } from 'vuex'

import businessAccountGroupService from 'Services/BusinessAccountGroupService'

const defaultCurrency = 'GBP'

export default {
  data () {
    return {
      isLoading: true,
      isLoadingBusinessAccountGroup: false,

      businessAccounts: [],

      selectedBusinessAccountNumber: null
    }
  },

  methods: {
    initialize (accountNumber = null) {
      return new Promise((resolve) => {
        this.$store.dispatch('getBeneficiaries', { context: this.context }).then(() => {
          this.getBusinessAccountGroups(accountNumber).then(() => resolve()).finally(() => {
            this.isLoading = false
          })
        })
      })
    },

    getBusinessAccountGroups (accountNumber = null) {
      return new Promise((resolve) => {
        this.isLoadingBusinessAccountGroup = true

        businessAccountGroupService.getAll(this.context).then(results => {
          this.businessAccounts = results.accountGroups

          if (accountNumber === null && this.businessAccounts.some(accountGroup => accountGroup.currency === defaultCurrency)) {
            this.selectedBusinessAccountNumber = (this.businessAccounts.find(accountGroup => accountGroup.currency === defaultCurrency).accountNumber)
          } else {
            this.selectedBusinessAccountNumber = accountNumber
          }

          resolve()
        }).finally(() => {
          this.isLoadingBusinessAccountGroup = false
        })
      })
    }
  },

  computed: {
    ...mapState({
      beneficiaries: state => state.beneficiary.beneficiaries
    }),

    beneficiariesOptions () {
      return this.beneficiaries.map(beneficiary => ({ value: beneficiary.beneficiaryId, label: beneficiary.beneficiaryName }))
    },

    businessAccountOptions () {
      return this.businessAccounts.map(account => ({ value: account.accountNumber, label: `${account.currency} | ${account.accountName} | ${account.accountNumber}` }))
    },

    businessAccount () {
      return this.businessAccounts.find(account => account.accountNumber === this.selectedBusinessAccountNumber)
    }
  }
}
